import { render, staticRenderFns } from "./bodyAPHV.vue?vue&type=template&id=31f0bd48&scoped=true"
import script from "./bodyAPHV.vue?vue&type=script&lang=js"
export * from "./bodyAPHV.vue?vue&type=script&lang=js"
import style0 from "./bodyAPHV.vue?vue&type=style&index=0&id=31f0bd48&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f0bd48",
  null
  
)

export default component.exports